import { createSlice } from "@reduxjs/toolkit";

export const sortedBySlice = createSlice({
    name:'sortedBy',
    initialState:{
        value:'',
    },
    reducers:{
        updateSortedBy:(state, action)=>{
             state.value = action.payload;
           
        }
    }
})

export const selectSortedBy = (state)=>state.sortedBy.value

export const { updateSortedBy } = sortedBySlice.actions

export default sortedBySlice.reducer